<template>
  <div id="app2">
    <div class="page">
      <div class="page-container">
        <div class="player-container" :class="this.link.theme">
          <div class="player-container box-shadow">
            <div class="container-for-player">
              <div
                :style="playerBackgroundStyle"
                class="song-player-bg player-content dimmed"
              ></div>
            </div>
            <div>
              <div class="song-info">
                <h3>{{ link.title }}</h3>
                <p class="subtitle">{{ link.subtitle }}</p>
              </div>
              <ul v-if="destinations.length" class="destinations">
                <li
                  v-for="destination in enabledDestinations"
                  :key="destination.id"
                >
                  <a
                    v-if="destination.type !== 'custom'"
                    :href="destination.url"
                    target="_blank"
                    class="destination destination-link"
                  >
                    <div class="destination">
                      <img
                        :src="
                          'https://vibe.to/img/destinations_svg/' +
                            destination.type +
                            '.png'
                        "
                        class="logo"
                        referrerpolicy="no-referrer"
                      />
                      <div class="cta">
                        {{ destination.cta || destination.default_cta }}
                      </div>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="destination.url"
                    target="_blank"
                    class="destination destination-link"
                  >
                    <div class="destination">
                      <img
                        v-if="destination.logo"
                        :src="destination.logo"
                        class="logo"
                        referrerpolicy="no-referrer"
                      />
                      <div v-else class="text">{{ destination.text }}</div>
                      <div class="cta">
                        {{ destination.cta || destination.default_cta }}
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!--                    <div v-if="link.display_artist_socials" class="socials">-->
          <!--                      <a-->
          <!--                        v-for="social in link.artist.socials"-->
          <!--                        :key="social.id"-->
          <!--                        :href="social.url"-->
          <!--                      >-->
          <!--                        <font-awesome-icon :icon="getSocialIcon(social)" />-->
          <!--                      </a>-->
          <!--                    </div>-->
        </div>
      </div>
      <div class="page-background">
        <img :src="link.image" />
      </div>
    </div>
  </div>
</template>

<script>
// https://jsfiddle.net/2ruff/pnb962o1/
export default {
  name: "LandingPagePreview",
  props: ["link", "destinations"],
  components: {},
  data() {
    return {};
  },
  computed: {
    enabledDestinations() {
      return this.destinations.filter(x => x.enabled === true);
    },
    pageBackgroundStyle() {
      return {
        backgroundImage: `url("${this.link.image}")`
      };
    },
    playerBackgroundStyle() {
      return {
        backgroundImage: `url("${this.link.image}"`
      };
    }
  },
  mounted() {
    // sort destinations
    // this.link.destinations.sort(function(a, b) {
    //   if (a.priority === b.priority) {
    //     if (a.clickthroughs > b.clickthroughs) return -1;
    //     if (a.clickthroughs === b.clickthroughs) return 0;
    //   } else {
    //     if (a.priority < b.priority) return -1;
    //   }
    //   return 1;
    // });
  },
  methods: {
    getSocialIcon(social) {
      if (social.type === "website") {
        return ["fas", "globe"];
      } else {
        return ["fab", social.type];
      }
    }
  }
};
</script>

<style scoped>
#app2 {
  max-width: 100%;
  max-height: 100%;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  /*font-size: 16px;*/
  /*word-spacing: 1px;*/
  /*-ms-text-size-adjust: 100%;*/
  /*-webkit-text-size-adjust: 100%;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*box-sizing: border-box;*/
  /*position: relative;*/
  /*min-height: 100%;*/
  /*height: auto;*/
  /*width: 100%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}
*,
:after,
:before {
  box-sizing: border-box;
  margin: 0;
}
.page {
  width: 100%;
  height: 100%;
  position: relative;
}
.page-container {
  width: 90%;
  max-width: 340px;
  /*padding-top: 20px;*/
  padding: 20px 0;
  margin: auto;
}
.player-container {
  border-radius: 6px;
  color: #fff;
  z-index: 10;
  position: relative;
}
.page-background {
  /*position: fixed;*/
  top: 0px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  right: 0px;
  overflow: hidden;
}
.page-background img {
  filter: blur(40px);
  transform: scale(1.2);
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.player-container .box-shadow {
  box-shadow: 0 0 28px 0 rgba(0, 0, 0, 0.8);
  border: 1px solid transparent;
}
.dark .player-container {
  border: 1px solid #ffffff63;
}
.container-for-player {
  height: 338px;
  display: block;
  position: relative;
  width: 100%;
}
.song-player-bg.dimmed {
  transition: all 1s ease;
}
.song-player-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  box-shadow: none;
  position: relative;
  transition: all 1s ease;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.player-content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.song-player {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: opacity 0.7s ease-in;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.player {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.player-button {
  transition: all 0.25s ease;
  display: block;
  border: 2px solid #fff;
  cursor: pointer;
  user-select: none;
}
.play.player-button,
.pause.player-button,
.prev.player-button,
.next.player-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 60px;
  position: relative;
}
.play.player-button,
.pause.player-button {
  height: 100px;
  width: 100px;
  margin: 0 20px;
}
.prev.player-button,
.next.player-button {
  height: 50px;
  width: 50px;
}
.pause-icon,
.play-icon {
  font-size: 40px;
  color: #fff;
}
.prev-icon,
.next-icon {
  font-size: 20px;
  color: #fff;
}
.player-button {
  background-position: center;
  transition: background 0.8s;
}
.player-button:hover {
  background: rgba(0, 0, 0, 0.75)
    radial-gradient(circle, transparent 1%, #000000 1%) center/15000%;
}
.player-button:active {
  background-color: rgba(0, 0, 0, 0.55);
  background-size: 100%;
  transition: background 0s;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
span.player-progress-container {
  width: 100%;
}
.player-progress {
  width: 100%;
  background: #000;
  background: rgba(0, 0, 0, 0.55);
}
.player-progress-top-layer {
  background: #fff;
  background: rgba(255, 255, 255, 0.8);
  width: 0;
  left: 0;
}
span.player-progress-container,
.player-progress,
.player-progress-top-layer {
  height: 6px;
  position: absolute;
  bottom: 0;
}
.song-info {
  padding: 15px;
  width: 100%;
}
.song-info {
  text-align: center;
}
.dark .song-info {
  /*background: #2b2b2b;*/
  background: #000000a1;
  border-top: 1px solid #ffffff63;
  color: #fff;
}
.light .song-info {
  background: #fff;
  color: #2b2b2b;
}

.song-info p {
  margin-top: 5px;
}
.song-info h4,
.song-info p {
  text-overflow: ellipsis;
  overflow: hidden;
}
.subtitle {
  font-size: 14px;
  line-height: 16px;
}
ul.destinations {
  padding: 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  transition: all 0.6s ease-in-out;
  overflow: hidden;
}
.dark ul.destinations {
  /*background: #2b2b2b;*/
  background: #000000a1;
  color: #fff;
}
.light ul.destinations {
  background: #fff;
  color: #000;
}
ul.destinations li {
  list-style: none;
  transition: 0.3s;
}
.light ul.destinations li {
  border-top: 1px solid #e1e1e4;
}
.dark ul.destinations li {
  border-top: 1px solid #ddd;
  border-top: 1px solid #ffffff63;
}
ul.destinations li:last-child {
  border-bottom: none;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
ul.destinations li div.destination {
  min-height: 70px;
  transition: all 0.6s ease-in-out;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.light ul.destinations li div.destination:hover {
  background: #eaeaea;
}
.dark ul.destinations li div.destination:hover {
  background: #222;
  background: #000000a1;
}
ul.destinations li .destination-link {
  cursor: pointer;
  background: transparent;
  width: 100%;
  border: none;
}
ul.destinations li div.destination .logo {
  max-height: 37px;
  max-width: 120px;
  float: left;
  margin: 17px;
}
.cta {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 10px 7px;
  text-align: center;
  border: 1.2px solid #ddd;
  border-radius: 4px;
  float: right;
  margin: 16px;
  font-size: 13px;
  width: 100px;
  transition: 0.3s;
  box-shadow: 0px 1px 2px rgb(0 0 0 / 28%);
  text-shadow: 0px 1px 2px rgb(0 0 0 / 28%);
}
.light .cta {
  color: #414754;
}
.dark .cta {
  color: #fff;
}
li:hover .cta {
  font-weight: inherit;
}
.light li:hover .cta {
  color: #fff;
  background: #2b2b2b;
  border-color: #2b2b2b;
}
.dark li:hover .cta {
  color: #2b2b2b;
  background: #fff;
  border-color: #fff;
}

.text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  text-decoration: none;
  padding: 24px 14px;
  display: inline-block;
  font-weight: 500;
  max-width: 200px;
}
.light .text {
  color: #2b2b2b;
}
.dark .text {
  color: #fff;
}
.socials {
  display: flex;
  justify-content: center;
}
.socials a {
  color: #ccc;
  margin: 8px;
  font-size: 30px;
}
.socials a:hover {
  color: white;
}
.footer {
  text-align: center;
  width: 330px;
  font-size: 13px;
  font-weight: 500;
  margin: 15px auto;
  color: #ccc;
  position: relative;
  line-height: 1.6;
  text-shadow: 0px 1px 2px rgb(0 0 0 / 28%);
}
.footer a {
  font-weight: bold;
  cursor: pointer;
  color: #fff;
}
.powered-wrapper {
  text-align: center;
}
.powered {
  padding: 5px 10px;
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
  text-align: center;
  display: inline-block;
  margin-bottom: 15px;
  transition: 0.3s;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.powered:hover {
  background: #eee;
  color: #222;
}
a {
  text-decoration: none;
}
.privacy-policy {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  color: #ccc;
  padding-left: 20px;
}
@media only screen and (max-width: 600px) {
  .privacy-policy {
    position: relative;
    text-align: center;
    padding-left: 0;
  }
}
</style>
